import { deriveAccessibleBrandColor } from '@marva/shared/email-composer/style-resolver'
import type { EmailBrandFacts } from '../../services/api'

/**
 * The five email brand facts' defaults and their one-line description — shared by How we look
 * (`EmailStylesSection`) and the Brand overview (MAR-384), so the two cannot describe the same
 * stored facts differently.
 *
 * The default brand colour is the shared resolver's own (an invalid colour resolves to it), so
 * the form and the email renderer cannot disagree about it — and it is merchant data, not app
 * styling, so it has no business as a literal here.
 */
export const DEFAULT_BRAND_COLOR: string = deriveAccessibleBrandColor('').original
export const DEFAULT_FACTS: EmailBrandFacts = { brandColor: DEFAULT_BRAND_COLOR, typeface: 'sans', corners: 'soft', paper: 'warm', logo: null }

const cap = (v: string) => v[0].toUpperCase() + v.slice(1)

/** "#1D4ED8 · Shop-name wordmark · Sans · Soft corners · White paper" */
export const describeFacts = (facts: EmailBrandFacts): string =>
  [
    facts.brandColor,
    facts.logo ? 'Your logo' : 'Shop-name wordmark',
    cap(facts.typeface),
    `${cap(facts.corners)} corners`,
    `${cap(facts.paper)} paper`,
  ].join(' · ')

/**
 * The width the shopper email lays itself out at: a 600px card inside 12px of padding each side
 * (624, email-composer/transactional.js), with room to spare so its max-width:600px mobile rule
 * never fires. Previews draw it at this width and scale it down rather than reflowing it (MAR-399).
 */
export const EMAIL_PREVIEW_WIDTH = 640
